import {Component} from '@angular/core';

@Component({
    selector: 'course-difference-instructor-administrator-support-article',
    template: `
        <ng-container i18n="@@support.articles.differenceInstructorAdministrator">
            <p>An <strong>instructor</strong> monitors the students of one or more classes. An instructor can only view data, but cannot enroll students or purchase licenses.</p>
            <p>An <strong>administrator</strong> has more administrative options. An administrator can create classes, enroll students and purchase licenses. An administrator has full access to all of the organization's data.</p>
            <p>Both instructors and administrators can be assigned to a class for follow-up. An administrator can therefore also take on the role of instructor.</p>

            <table class="comparisonTable">
                <tr>
                    <th>&nbsp;</th>
                    <th>Instructor</th>
                    <th>Administrator</th>
                </tr>
                <tr>
                    <th>
                        View the course
                    </th>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        Create their own exercises
                    </th>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        Follow up student results
                    </th>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                        <br />
                        <span class="tableInfo">only from their own classes</span>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                        <br />
                        &nbsp;
                    </td>
                </tr>
                <tr>
                    <th>
                        Enroll students
                    </th>
                    <td>
                        <mat-icon class="closeIcon">close</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        Order licenses
                    </th>
                    <td>
                        <mat-icon class="closeIcon">close</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        Customize organization settings
                    </th>
                    <td>
                        <mat-icon class="closeIcon">close</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        Add instructors or administrators
                    </th>
                    <td>
                        <mat-icon class="closeIcon">close</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
                <tr>
                    <th>
                        View invoices
                    </th>
                    <td>
                        <mat-icon class="closeIcon">close</mat-icon>
                    </td>
                    <td>
                        <mat-icon class="checkIcon">check</mat-icon>
                    </td>
                </tr>
            </table>
        </ng-container>
    `
})
export class DifferenceInstructorAdministratorSupportArticleComponent {
}
